import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { protectedResources } from '../auth/auth.config';
import { NoFlyZone } from '../models/geoasset.model';

@Injectable({
  providedIn: 'root',
})
export class NoFlyZoneService {
  constructor(private http: HttpClient) {}

  // TODO: change later, when selection becomes relevant
  public hoveredNoFlyZone: WritableSignal<NoFlyZone | undefined> = signal<
    NoFlyZone | undefined
  >(undefined);
  public selectedNoFlyZone: WritableSignal<NoFlyZone | undefined> = signal<
    NoFlyZone | undefined
  >(undefined);

  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  getNoFlyZones() {
    const headers = new HttpHeaders({
      accept: 'application/vnd.qsconnect.geoasset.noflyzone.detail+json',
    });
    return this.http.get<NoFlyZone[]>(
      `${this.apiEndpoint}/assets/geo/noflyzone`,
      {
        headers,
      },
    );
  }

  createNoFlyZone(NoFlyZone: NoFlyZone) {
    const headers = new HttpHeaders({
      'Content-Type':
        'application/vnd.qsconnect.geoasset.noflyzone.create+json',
      accept: 'application/vnd.qsconnect.geoasset.noflyzone.detail+json',
    });
    return this.http.post<NoFlyZone>(
      `${this.apiEndpoint}/assets/geo/noflyzone`,
      NoFlyZone,
      {
        headers,
      },
    );
  }

  editNoFlyZone(id: string, changes: Partial<NoFlyZone>) {
    const headers = new HttpHeaders({
      'Content-Type':
        'application/vnd.qsconnect.geoasset.noflyzone.create+json',
      accept: 'application/vnd.qsconnect.geoasset.noflyzone.detail+json',
    });
    return this.http.put<NoFlyZone>(
      `${this.apiEndpoint}/assets/geo/noflyzone/${id}`,
      changes,
      {
        headers,
      },
    );
  }
}
